import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: theme.palette.grey[800],
    height: 30,
    boxShadow: 'unset',
    padding: `0 ${theme.spacing(1.5)}px`,
    margin: `${theme.spacing(0.5)}px 0`,
    textTransform: 'unset',
    display: 'flex'
  },
  rootSelected: {
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark
    },
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main
  },
  icon: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey[800],
    paddingRight: theme.spacing(1)
  },
  iconSelected: {
    color: theme.palette.common.white
  }
}));

type BreadcrumbProps = {
  selected?: boolean;
  url: string;
  name: string;
  Icon?: any;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ selected, url, name, Icon }): JSX.Element => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const handleOnClick = React.useCallback((): void => {
    if (location.pathname === url) return;
    history.push(url);
  }, [history, location.pathname, url]);

  //   const [forceRenderRetries, forceRender] = useState(breadcrumbTextOverride ? 0 : 10);

  //   /**
  //    * This is a huge hack to fix the race condition where on refresh, the page finishes loading before apollo cache is up-to-date
  //    */
  //   const breadcrumbIsCorrect = breadcrumb?.isCorrect;
  //   useEffect(() => {
  //     if (forceRenderRetries < 10 && !breadcrumbIsCorrect) {
  //       const forceRenderTimeout = setTimeout(() => forceRender(forceRenderRetries + 1), 500);
  //       return (): void => window.clearTimeout(forceRenderTimeout);
  //     }
  //   }, [forceRenderRetries, forceRender, breadcrumbIsCorrect]);

  return (
    <Fab
      variant="extended"
      aria-label="add"
      classes={{
        root: clsx(classes.root, {
          [classes.rootSelected]: selected
        })
      }}
      onClick={handleOnClick}
    >
      {Icon && (
        <Icon
          classes={{
            root: clsx(classes.icon, {
              [classes.iconSelected]: selected
            })
          }}
        />
      )}
      <Typography variant="subtitle2">{name}</Typography>
    </Fab>
  );
};

export default Breadcrumb;
